export default __webpack_public_path__ + "static/media/Wall_Conveyor_x1_Orange.256.df858808.png";